import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { NavigationModule } from "navigation/navigation.module";
import { FirstTimeLogin } from "./first-time-login";
@NgModule({
  declarations: [FirstTimeLogin],
  imports: [
    IonicPageModule.forChild(FirstTimeLogin),
    TranslateModule.forChild(),
    NavigationModule,
    CommonComponentsModule,
  ],
  entryComponents: [FirstTimeLogin],
  exports: [FirstTimeLogin],
})
export class FirstTimeLoginCognitoModule {}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/first-time-login/first-time-login.module.ts